import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { theme } from '../style/theme';

type Props = {
  open: boolean;
};

export const BatchUploadProcessingModal = ({ open }: Props) => {
  const { t } = useTranslation('xml-upload');

  return (
    <Dialog open={open} aria-labelledby="modal-title" aria-describedby="modal-description">
      <DialogTitle id={'modal-title'} align={'left'}>
        {t('processing.title')}
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          display: 'flex',
          p: 4,
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <img
          alt={t('animationAlt') as string}
          src={'/assets/img/xml-processing.gif'}
          height={250}
          width={250}
          style={{ borderRadius: theme.shape.borderRadius }}
        />

        <Typography>{t('processing.description')}</Typography>
      </DialogContent>
    </Dialog>
  );
};
